(function() {
'use strict';

angular.module('TR')
    .directive('shortlistToggle', shortlistToggle);

function shortlistToggle(shortlistService, $rootScope) {
    return {
        restrict: 'E',
            replace: true,
            scope: {
                hotel: '='
            },
            templateUrl: 'partials/home/directivetemplate?type=ShortlistToggle',
            link(scope) {
                const cancel = scope.$watch('hotel', v => {
                    if (v) {
                        cancel();

                        shortlistService.isHotelShortlisted(scope.hotel)
                            .then(shortlisted => scope.hotel.inShortlist = shortlisted);

                        scope.toggleShortlist = function(e) {
                            e.preventDefault();
                            shortlistService.toggleHotel(scope.hotel).then(shortlisted => {
                                scope.hotel.inShortlist = shortlisted;
                                scope.$emit('hotelShortlistStatusUpdated', scope.hotel);
                            });
                            e.stopPropagation();
                        };

                        $rootScope.$on('hotelShortlistStatusUpdated', function(ev, args) {
                            if (scope.hotel.Id === args.Id) {
                                scope.hotel.inShortlist = args.inShortlist;
                            }
                        });
                    }
                });
            }
    };
}
})();
